import { useState, useEffect } from 'react';
import { FooterModel } from '@/types/footer';
import { fetchFooterData } from '@/lib/api/footer';
import { mapFooterFromApiWithDict } from '@/lib/mappers/footerMapper';

/**
 * Custom hook for footer data management
 */
export function useFooterData(dict: any, initialData?: FooterModel) {
  const [data, setData] = useState<FooterModel | null>(initialData || null);
  const [loading, setLoading] = useState(!initialData);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (initialData) return; // Don't fetch if we have initial data

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const apiData = await fetchFooterData();
        const mappedData = mapFooterFromApiWithDict(apiData, dict);
        
        setData(mappedData);
      } catch (err) {
        console.error('Error fetching footer data:', err);
        setError(err instanceof Error ? err.message : 'Unknown error');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dict, initialData]);

  return { data, loading, error };
}
